import type from './types';

const INITIAL_STATE = {
  loading: true,
  loadingPartner: true,
  loadingGiveaways: true,
  list: {
    content: [],
  },
  listPartners: {
    content: [],
  },
  listGiveaways: {
    content: [],
  },
  detail: {},
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.LIST_FETCHED:
      return {
        ...state,
        list: { content: action.payload.data },
        loading: false,
      };
    case type.LIST_LOAD:
      return { ...state, loading: action.payload };
    case 'PARTNERS_FETCHED':
      return {
        ...state,
        listPartners: { content: action.payload.data },
        loadingPartner: false,
      };
    case 'PARTNERS_LOAD':
      return { ...state, loadingPartner: action.payload };
    case 'GIVEAWAYS_FETCHED':
      return {
        ...state,
        listGiveaways: { content: action.payload.data },
        loadingGiveaways: false,
      };
    case 'GIVEAWAYS_LOAD':
      return { ...state, loadingGiveaways: action.payload };
    case type.ITEM_DETAIL:
      return {
        ...state,
        detail: action.payload,
        loading: false,
      };
    case type.BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };
    default:
      return state;
  }
};
